<template>
    <section id="form_section">
        <div class="container">
            <div class="service_header">
                <h1 class="service_title">Конфігуратор ЩО125</h1>
                <a href="javascript:void(0)" v-on:click="modal_info = true" class="info_btn">
                    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path id="info-icon" d="M9.5 5H11.5V7H9.5V5ZM9.5 9H11.5V15H9.5V9ZM10.5 0C4.98 0 0.5 4.48 0.5 10C0.5 15.52 4.98 20 10.5 20C16.02 20 20.5 15.52 20.5 10C20.5 4.48 16.02 0 10.5 0ZM10.5 18C6.09 18 2.5 14.41 2.5 10C2.5 5.59 6.09 2 10.5 2C14.91 2 18.5 5.59 18.5 10C18.5 14.41 14.91 18 10.5 18Z" fill="#356EEF"/>
                    </svg>
                    Опис роботи сервісу
                </a>
            </div>

            <div class="top_bar">
                <p class="top_bar_title">Специфікація</p>
                <a class="add_btn" href="javascript:void(0)" @click="openAddModal">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z" fill="white"/>
                    </svg>
                    Додати щит
                </a>
            </div>

            <div class="main_table_container">
            <table class="main_table">
                <tr>
                    <th class="main_table_title" style="width: 42px;">№</th>
                    <th class="main_table_title" style="text-align: left; width: 615px; padding-left:16px;">Найменування</th>
                    <th class="main_table_title" style="width: 145px;">Кількість, шт.</th>
                    <th class="main_table_title" style="width: 183px;">Ціна, грн. з ПДВ</th>
                    <th class="main_table_title" style="width: 185px;">Сума, грн. з ПДВ</th>
                    <th class="main_table_title" style="width: 126px;"></th>
                </tr>
                <tr v-for="(item, i) in items" :key="`item_${i}`">
                    <td class="main_table_row" style="text-align: center;">{{ i+1 }}</td>
                    <td class="main_table_row" style="text-align: left; padding-left:16px;">{{ item.title }}</td>
                    <td class="main_table_row" style="text-align: center;">
                        <input class="main_table_count_input" v-model="item.count" >
                    </td>
                    <td class="main_table_row" style="text-align: center;">{{ numberWithSpaces(item.price) }}</td>
                    <td class="main_table_row" style="text-align: center;">{{ numberWithSpaces( item.price * item.count ) }}</td>
                    <td class="main_table_row" style="text-align: center;">
                        <div class="edit_row">
                            <a href="javascript:void(0)" v-on:click="editProduct(i)" v-tooltip.bottom="'Редагувати'">
                                <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0 15.2496V18.9996H3.75L14.81 7.93957L11.06 4.18957L0 15.2496ZM17.71 5.03957C18.1 4.64957 18.1 4.01957 17.71 3.62957L15.37 1.28957C14.98 0.89957 14.35 0.89957 13.96 1.28957L12.13 3.11957L15.88 6.86957L17.71 5.03957Z" fill="#356EEF"/>
                                </svg>
                            </a>
                            <a href="javascript:void(0)" v-on:click="copyItem(i, item)" v-tooltip.bottom="'Скопіювати щит'">
                                <svg width="19" height="22" viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14 0H2C0.9 0 0 0.9 0 2V16H2V2H14V0ZM17 4H6C4.9 4 4 4.9 4 6V20C4 21.1 4.9 22 6 22H17C18.1 22 19 21.1 19 20V6C19 4.9 18.1 4 17 4ZM17 20H6V6H17V20Z" fill="#356EEF"/>
                                </svg>
                            </a>
                            <a href="javascript:void(0)" v-on:click="deleteItem(i)" v-tooltip.bottom="'Видалити'">
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="#356EEF"/>
                                </svg>
                            </a>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="3" style="height: 98px;padding-left:30px;">
                        <div class="total_btns">
                            <a class="view_spec_btn" :class="{ 'disabled': !items.length }" v-on:click="() => { getSpec() }">Переглянути специфікацію</a>
                            <a class="download_spec" :class="{ 'disabled': !items.length }" v-on:click="() => {getExcel()}">Завантажити специфікацію в Excel</a>
                        </div>
                    </td>
                    <td colspan="3" style="height: 98px;">
                        <div class="total_summ">
                            <span>Разом</span>
                            <span>{{ summTotal() }}</span>
                        </div>
                    </td>
                </tr>
            </table>
            </div>
        </div>


        <div class="overlay" :class="{'zindexed': opensSliderModal || warningPopup}" v-if="modal_info || add_item_modal || modal_total || opensSliderModal || warningPopup" v-on:click="closeModals"></div>
        
        <div class="modal description_modal" v-if="modal_info">
            <div class="modal_container">
                <div class="modal_header">
                    <p class="modal_header_title">Опис роботи сервісу</p>
                    <svg id="close_modal" v-on:click="modal_info = false" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                    </svg>
                </div>
                <div class="modal_content" v-html="text"></div>
            </div>
        </div>

        <div class="modal add_item_modal" v-if="add_item_modal">
            <div class="modal_container">
                <div class="modal_header">
                    <p class="modal_header_title" v-if="!editMode">Додати щит</p>
                    <p class="modal_header_title" v-else>Редагування {{ preItem.title }}</p>
                    <svg id="close_modal" v-on:click="add_item_modal = false" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                    </svg>
                </div>
                <div id="addMoadal" class="modal_content">
                    <p class="subtitle">Дані про щит:</p>
                    <div class="form_row">
                        <div class="info_form">
                            <div class="input_group">
                                <div class="form_input_item">
                                    <span class="form_input_title">Назва щитка *</span>
                                    <input class="form_input" :class="{ 'border-danger': errors.title }" @keyup="clearErrors()" v-model="preItem.title">
                                    <p class="error_text" v-if="errors.title">Обов'язкове поле</p>
                                </div>
                                <div class="form_input_item">
                                    <span class="form_input_title">Кількість *</span>
                                    <input class="form_input" :class="{ 'border-danger': errors.count }" @keyup="clearErrors()" @input="acceptNumber" v-model="preItem.count">
                                    <p class="error_text" v-if="errors.count">Обов'язкове поле</p>
                                </div>
                                <div class="form_input_item">
                                    <div class="form_input_title_row">
                                        <span class="form_input_title">Тех. облік електроенергії</span>
                                        <a v-if="preItem.accountings_product && preItem.accountings_product.file" :href="preItem.accountings_product.file" target="_blank" class="accountings_type_file_link">Опис системи</a>
                                    </div>
                                    <select class="form_select" :class="{ 'border-danger': errors.accountings_type, 'non_selected': preItem.accountings_type=='Ні'}" v-model="preItem.accountings_type" v-on:change="getAccountings">
                                        <option :value="'Ні'" selected>Ні</option>
                                        <option v-for="(accounting, i) in accountings" :key="`value_${i}`" :value="accounting">{{ accounting }}</option>
                                    </select>
                                    <p class="error_text" v-if="errors.accountings_type">Обов'язкове поле</p>
                                </div>
                            </div>

                            <div class="form_border">
                                <div class="form_input_item_checkbox">
                                    <input class="checkbox_input" v-model="preItem.no_bodie" @change="clearErrors()" type="checkbox" /><label class="form_input_title">Без корпусу</label>
                                </div>
                                <div class="input_group">
                                    <div class="form_input_item">
                                        <span class="form_input_title" :class="{'input-disabled': disabledShield}">Захист *</span>
                                        <div class="select_container">
                                            <select class="form_select" :class="{ 'border-danger': errors.protection, 'input-disabled': disabledShield, 'non_selected': !preItem.protection }" :disabled="disabledShield" v-model="preItem.protection" v-on:change="getBodies">
                                                <option :value="null" disabled selected>Вибрати</option>
                                                <option v-for="(protection, i) in protections" :key="`value_${i}`" :value="protection">{{ protection }}</option>
                                            </select>
                                            <svg v-if="preItem.protection" class="clear_icon" @click="clearBodies('protection')" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M11.25 1.8075L10.1925 0.75L6 4.9425L1.8075 0.75L0.75 1.8075L4.9425 6L0.75 10.1925L1.8075 11.25L6 7.0575L10.1925 11.25L11.25 10.1925L7.0575 6L11.25 1.8075Z" fill="#D83A36"/>
                                            </svg>
                                        </div>
                                        <p class="error_text" v-if="errors.protection">Обов'язкове поле</p>
                                    </div>
                                    <div class="form_input_item">
                                        <span class="form_input_title" :class="{'input-disabled': disabledShield}">Виконання *</span>
                                        <div class="select_container">
                                            <select class="form_select" :class="{ 'border-danger': errors.implementation, 'input-disabled': disabledShield, 'non_selected': !preItem.implementation }" :disabled="disabledShield" v-model="preItem.implementation" v-on:change="getBodies">
                                                <option :value="null" disabled selected>Вибрати</option>
                                                <option v-for="(implementation, i) in implementations" :key="`value_${i}`" :value="implementation">{{ implementation }}</option>
                                            </select>
                                            <svg v-if="preItem.implementation" class="clear_icon" @click="clearBodies('implementation')" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M11.25 1.8075L10.1925 0.75L6 4.9425L1.8075 0.75L0.75 1.8075L4.9425 6L0.75 10.1925L1.8075 11.25L6 7.0575L10.1925 11.25L11.25 10.1925L7.0575 6L11.25 1.8075Z" fill="#D83A36"/>
                                            </svg>
                                        </div>
                                        <p class="error_text" v-if="errors.implementation">Обов'язкове поле</p>
                                    </div>
                                    <div class="form_input_item">
                                        <span class="form_input_title" :class="{'input-disabled': disabledShield}">Кількість модулів *</span>
                                        <div class="select_container">
                                            <select class="form_select" :class="{ 'border-danger': errors.modules_count, 'input-disabled': disabledShield, 'non_selected': !preItem.modules_count }" :disabled="disabledShield"  v-model="preItem.modules_count" v-on:change="getBodies">
                                                <option :value="null" disabled selected>Вибрати</option>
                                                <option v-for="(modules_count, i) in modules_counts" :key="`value_${i}`" :value="modules_count">{{ modules_count }}</option>
                                            </select>
                                            <svg v-if="preItem.modules_count" class="clear_icon" @click="clearBodies('modules_count')" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M11.25 1.8075L10.1925 0.75L6 4.9425L1.8075 0.75L0.75 1.8075L4.9425 6L0.75 10.1925L1.8075 11.25L6 7.0575L10.1925 11.25L11.25 10.1925L7.0575 6L11.25 1.8075Z" fill="#D83A36"/>
                                            </svg>

                                        </div>
                                        <p class="error_text" v-if="errors.modules_count">Обов'язкове поле</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="item_image" v-on:click="opensSliderModalAction()">
                            <template v-if="preItem.selectedProductMediaFiles.length && preItem.selectedProductMediaFiles[selectedMediaIndex].type === 'photo' && !preItem.no_bodie">
                                <img :src="preItem.selectedProductMediaFiles[selectedMediaIndex].url" class="trans_img" height="131"/>
                            </template>
                            <template v-else-if="preItem.selectedProductMediaFiles.length && preItem.selectedProductMediaFiles[selectedMediaIndex].type === 'video' && !preItem.no_bodie">
                            <iframe type="text/html"
                                class="trans_img"
                                height="131"
                                :src="preItem.selectedProductMediaFiles[selectedMediaIndex].url"
                                frameborder="0"/>
                            </template>

                            <template v-else-if="preItem.no_bodie">
                                <img :src="defaultMedia[0].url" class="trans_img" height="131" alt="image">
                            </template>
                            <template v-else>
                                <img :src="defaultMedia[0].url" class="trans_img" height="131" alt="image">
                            </template>
                        </div>
                    </div>

                    <div class="variation_table">
                        <p class="subtitle">Підбір автоматів та модульних контакторів</p>
                        <div class="line_table">
                            <table style="z-index:1;width:100%;" border=1>
                                <thead>
                                    <th class="ol_num">№</th>
                                    <th class="ol_eq">Обладнання</th>
                                    <th class="ol_p_ctn">Кількість полюсів</th>
                                    <th class="ol_char">Характеристка, виконання</th>
                                    <th class="ol_curr">Струм, виконання</th>
                                    <th class="ol_cnt">Кількість</th>
                                    <th class="ol_article">Артикул</th>
                                    <th class="ol_close"></th>
                                </thead>
                                <tbody>
                                    <tr v-for="(line_product, i) in line_products" :key="`product_${i}`" :class="{'errors': lineProductErrors.includes(i) }">
                                        <td class="ol_num">{{ i + 1 }}</td>
                                        <td class="ol_eq">
                                            <div v-if="!isMobile()" class="ol_eq__select">
                                                <CustomSelect
                                                    :def="'Вибрати'"
                                                    :options="equipments"
                                                    class="select"
                                                    :value="line_product.equipment"
                                                    v-model="line_product.equipment"
                                                    @update:modelValue="getArticle(i, true)"
                                                />
                                            </div>

                                            <select class="option_select" :class="{'non_selected': !line_product.equipment}" v-on:change="getArticle(i, true)" v-model="line_product.equipment" v-else>
                                                <option :value="null" disabled>Вибрати</option>
                                                <option v-for="(equipment, k) in equipments" :key="`equipment_${k}`" :value="equipment">{{ equipment }}</option>
                                            </select>
                                        </td>
                                        <td class="ol_p_ctn">
                                            <div v-if="!isMobile()" class="ol_p_ctn__select">
                                                <CustomSelect
                                                    :def="'Вибрати'"
                                                    :options="line_product.pole_numbers"
                                                    class="select"
                                                    :value="line_product.pole_number"
                                                    v-model="line_product.pole_number"
                                                    @update:modelValue="getArticle(i)"
                                                />
                                            </div>
                                            <select class="option_select" :class="{'non_selected': !line_product.pole_number}" v-on:change="getArticle(i)" v-model="line_product.pole_number" v-else>
                                                <option :value="null" disabled>Вибрати</option>
                                                <option v-for="(pole_number, k) in line_product.pole_numbers" :key="`pole_number_${k}`" :value="pole_number">{{ pole_number }}</option>
                                            </select>
                                        </td>
                                        <td class="ol_char">
                                            <div v-if="!isMobile()" class="ol_char__select">
                                                <CustomSelect
                                                    :def="'Вибрати'"
                                                    :options="line_product.characteristics"
                                                    class="select"
                                                    :value="line_product.characteristic"
                                                    v-model="line_product.characteristic"
                                                    @update:modelValue="getArticle(i)"
                                                />
                                            </div>

                                            <select class="option_select" :class="{'non_selected': !line_product.characteristic}" v-on:change="getArticle(i)" v-model="line_product.characteristic" v-else>
                                                <option :value="null" disabled>Вибрати</option>
                                                <option v-for="(characteristic, k) in line_product.characteristics" :key="`characteristic_${k}`" :value="characteristic">{{ characteristic }}</option>
                                            </select>
                                        </td>
                                        <td class="ol_curr">
                                            <div v-if="!isMobile()" class="ol_curr__select">
                                                <CustomSelect
                                                    :def="'Вибрати'"
                                                    :options="line_product.powers"
                                                    class="select"
                                                    :value="line_product.power"
                                                    v-model="line_product.power"
                                                    @update:modelValue="getArticle(i)"
                                                />
                                            </div>

                                            <select class="option_select" :class="{'non_selected': !line_product.power}" v-on:change="getArticle(i)" v-model="line_product.power" v-else>
                                                <option :value="null" disabled>Вибрати</option>
                                                <option v-for="(power, k) in line_product.powers" :key="`power_${k}`" :value="power">{{ power }}</option>
                                            </select>
                                        </td>
                                        <td class="ol_cnt count_td">
                                            <div class="count">
                                                <a href="javascript:void(0)" v-on:click="minusProductCount(i)">-</a>
                                                <span>{{ line_product.count }}</span>
                                                <a href="javascript:void(0)" v-on:click="plusProductCount(i)">+</a>
                                            </div>
                                        </td>
                                        <td class="article ol_article"><a :href="line_product.article ? line_product.article.tech_char : null" target="_blank">{{ line_product.article ? line_product.article.article : null }}</a></td>
                                        <td class="ol_close">
                                            <a href="javascript:void(0)" v-on:click="deleteProduct(i)">
                                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="#356EEF"/>
                                                </svg>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="8">
                                            <div class="variation_table_footer">
                                                <a href="javascript:void(0)" v-on:click="addProduct()" class="add_btn">
                                                    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <circle cx="13" cy="13" r="13" fill="#356EEF"/>
                                                        <g clip-path="url(#clip0_2325_54844)">
                                                        <rect width="11" height="20" transform="translate(8 1)" fill="white" fill-opacity="0.01"/>
                                                        <path d="M14.012 12.334V8.392H12.788V12.334H8.864V13.558H12.788V17.5H14.012V13.558H17.936V12.334H14.012Z" fill="white"/>
                                                        </g>
                                                        <defs>
                                                        <clipPath id="clip0_2325_54844">
                                                        <rect width="11" height="20" fill="white" transform="translate(8 1)"/>
                                                        </clipPath>
                                                        </defs>
                                                    </svg>
                                                    <span>Додати</span>
                                                </a>
                                                <div class="module_ctn_container">
                                                    <div class="module_ctn">
                                                        <p class="module_ctn_title">Кількість модулів</p>
                                                        <input :class="{ 'border-danger': !preItem.no_bodie && ((summModules1 + summModules3) > summModules2) }" class="module_ctn_input" :value="Math.round((summModules1 + summModules3)) + '/' + Math.round(summModules2)" >
                                                    </div>
                                                    <p v-if="!preItem.no_bodie && ((summModules1 + summModules3) > summModules2)" class="error_text" style="display: flex;justify-content: end;">Перевищено</p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="btn_container" v-if="!payload">
                            <a v-if="!editMode" class="view_spec_btn" :class="{ 'disabled': hasFormError }" v-on:click="addShield()">Додати до специфікації</a>
                            <a v-else class="view_spec_btn" :class="{ 'disabled': hasFormError }" v-on:click="addShield()">Зберегти</a>
                        </div>
                        <div class="btn_container" v-else>
                            <a class="view_spec_btn disabled">Завантаження..</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal modal_total" v-if="modal_total">
            <div class="modal_header">
                <p class="modal_header_title">Специфікація</p>
                <svg id="close_modal" v-on:click="() => {modal_total = false; summarize = false;}" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                </svg>
            </div>
            <div class="modal_content">
                <br>
                <br>

                <template v-if="!summarize">
                    <template v-for="(item, i) in specItems" :key="`itemi_${i}`">
                        <p class="title">{{ item.title }}</p>
                        <table style="width:100%; z-index:1;" border=1>
                            <thead>
                                <th class="total_key summ_text">#</th>
                                <th class="total_title summ_text">Найменування</th>
                                <th class="total_maker summ_text">Виробник</th>
                                <th class="total_count summ_text">Кількість</th>
                                <th class="total_od summ_text">Од. Вим.</th>
                                <th class="total_price center summ_text">Ціна, грн. без ПДВ</th>
                                <th class="total_summ2 center summ_text">Сума, грн. без ПДВ</th>
                                <th class="total_tech center summ_text">Посилання на тех. хар.</th>
                            </thead>
                            <tbody>
                                <tr v-for="(item, i) in item.products" :key="`item_${i}`">
                                    <td class="total_key">{{ i+1 }}</td>
                                    <td class="total_title">{{ item.description }}</td>
                                    <td class="total_maker">{{ item.maker }}</td>
                                    <td class="total_count">{{ item.count }}</td>
                                    <td class="total_od">шт.</td>
                                    <td class="total_price">{{ numberWithSpaces(item.price_nds/1.2) }}</td>
                                    <td class="total_summ2">{{ numberWithSpaces((item.price_nds/1.2) * item.count) }}</td>
                                    <td class="total_tech">
                                        <a :href="item.tech_char" target="_blank">
                                            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M9 5.53711H11V7.53711H9V5.53711ZM9 9.53711H11V15.5371H9V9.53711ZM10 0.537109C4.48 0.537109 0 5.01711 0 10.5371C0 16.0571 4.48 20.5371 10 20.5371C15.52 20.5371 20 16.0571 20 10.5371C20 5.01711 15.52 0.537109 10 0.537109ZM10 18.5371C5.59 18.5371 2 14.9471 2 10.5371C2 6.12711 5.59 2.53711 10 2.53711C14.41 2.53711 18 6.12711 18 10.5371C18 14.9471 14.41 18.5371 10 18.5371Z" fill="#356EEF"/>
                                            </svg>
                                        </a>
                                    </td>
                                </tr>
                                <tr class="totat_tr">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td class="summ_text summ_point" colspan="2">Сума без ПДВ</td>
                                    <td class="summ_text summ_value">{{ summProducts(item.products) }}</td>
                                    <td></td>
                                </tr>
                                <tr class="totat_tr">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td class="summ_text summ_point" colspan="2">ПДВ</td>
                                    <td class="summ_text summ_value">{{ productsPdw(item.products) }}</td>
                                    <td></td>
                                </tr>
                                <tr class="totat_tr">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td class="summ_text summ_point" colspan="2">Сума з ПДВ</td>
                                    <td class="summ_text summ_value">{{ summProductsPdw(item.products) }}</td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                        <br>
                        <br>
                    </template>
                </template>
                <template v-if="summarize">
                    <table style="width:100%; z-index:1;" border=1>
                        <thead>
                            <th class="total_key summ_text">#</th>
                            <th class="total_title summ_text">Найменування</th>
                            <th class="total_maker summ_text">Виробник</th>
                            <th class="total_count summ_text">Кількість</th>
                            <th class="total_od summ_text">Од. Вим.</th>
                            <th class="total_price center summ_text">Ціна, грн. без ПДВ</th>
                            <th class="total_summ2 center summ_text">Сума, грн. без ПДВ</th>
                            <th class="total_tech center summ_text">Посилання на тех. хар.</th>
                        </thead>
                        <tbody>
                            <tr v-for="(item, i) in summarizeResult" :key="`item_${i}`">
                                <td class="total_key">{{ i+1 }}</td>
                                <td class="total_title">{{ item.description }}</td>
                                <td class="total_maker">{{ item.maker }}</td>
                                <td class="total_count">{{ item.count }}</td>
                                <td class="total_od">шт.</td>
                                <td class="total_price">{{ numberWithSpaces(item.price_nds/1.2) }}</td>
                                <td class="total_summ2">{{ numberWithSpaces((item.price_nds/1.2) * item.count) }}</td>
                                <td class="total_tech">
                                    <a :href="item.tech_char" target="_blank">
                                        <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9 5.53711H11V7.53711H9V5.53711ZM9 9.53711H11V15.5371H9V9.53711ZM10 0.537109C4.48 0.537109 0 5.01711 0 10.5371C0 16.0571 4.48 20.5371 10 20.5371C15.52 20.5371 20 16.0571 20 10.5371C20 5.01711 15.52 0.537109 10 0.537109ZM10 18.5371C5.59 18.5371 2 14.9471 2 10.5371C2 6.12711 5.59 2.53711 10 2.53711C14.41 2.53711 18 6.12711 18 10.5371C18 14.9471 14.41 18.5371 10 18.5371Z" fill="#356EEF"/>
                                        </svg>
                                    </a>
                                </td>
                            </tr>
                            <tr class="totat_tr">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td class="summ_text summ_point" colspan="2">Сума без ПДВ</td>
                                <td class="summ_text summ_value">{{ summProducts(summarizeResult) }}</td>
                                <td></td>
                            </tr>
                            <tr class="totat_tr">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td class="summ_text summ_point" colspan="2">ПДВ</td>
                                <td class="summ_text summ_value">{{ productsPdw(summarizeResult) }}</td>
                                <td></td>
                            </tr>
                            <tr class="totat_tr">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td class="summ_text summ_point" colspan="2">Сума з ПДВ</td>
                                <td class="summ_text summ_value">{{ summProductsPdw(summarizeResult) }}</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                    <br>
                    <br>
                </template>
            </div>
            <div class="modal_bottom">
                <a href="javascript:void(0)" v-on:click="() => {modal_total = false; summarize = false;}" class="modal_bottom_link">Повернутись до конфігуратора</a>
                <div class="modal_bottom__btns">
                    <a href="javascript:void(0)" v-on:click="doSummarize()" class="avr_summ_btn">
                        <span v-if="!summarize">Підсумувати</span>
                        <span v-if="summarize">Розділити</span>
                    </a>
                    <a href="javascript:void(0)" v-on:click="getExcel()" class="avr_excel_btn">Завантажити Excel</a>
                </div>
            </div>

            <div class="commercial_offer">
                <div class="commercial_offer_header" @click="dropCommercialOfferForm()">
                    <span class="commercial_offer_header_title">Замовити комерційну пропозицію</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" :class="{commercial_offer_drop_row: is_drop_commercial_offer}">
                        <g clip-path="url(#clip0_7979_151607)">
                            <path d="M16.59 8.58984L12 13.1698L7.41 8.58984L6 9.99984L12 15.9998L18 9.99984L16.59 8.58984Z" fill="#356EEF"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_7979_151607">
                            <rect width="24" height="24" fill="white" transform="matrix(-1 0 0 1 24 0)"/>
                            </clipPath>
                        </defs>
                    </svg>
                </div>
                <div class="commercial_offer_body" v-if="is_drop_commercial_offer">
                    <p class="commercial_offer_body_subtitle">Заповніть форму</p>
                    
                    <div class="flex-group customer_info">
                        <div class="flex_form">
                            <div class="flex-row">
                                <div class="form_grid">
                                    <div class="form_group">
                                        <label class="form_label">Організація</label>
                                        <input class="form_input" :class="{ 'border-danger': commercialOfferDataErrors.organization }" v-model="commercialOfferData.organization" type="text" placeholder="Назва" />
                                    </div>
                                    <div class="form_group">
                                        <label class="form_label">Контактна особа</label>
                                        <input class="form_input" v-model="commercialOfferData.name" type="text" placeholder="ПІБ" />
                                    </div>
                                </div>
                                <div class="form_grid">
                                    <div class="form_group">
                                        <label class="form_label">Номер телефону *</label>
                                        <input class="form_input" :class="{ 'border-danger': commercialOfferDataErrors.phone }" @input="acceptNumber" v-model="commercialOfferData.phone" type="text" placeholder="+380" />
                                        <p class="error_text" v-if="commercialOfferDataErrors.phone">Обов'язкове поле</p>
                                    </div>
                                    <div class="form_group">
                                        <label class="form_label">Електронна пошта *</label>
                                        <input class="form_input" :class="{ 'border-danger': commercialOfferDataErrors.email }" v-model="commercialOfferData.email" type="text" placeholder="Email" />
                                        <p class="error_text" v-if="commercialOfferDataErrors.email">Обов'язкове поле</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="flex_form">
                            <div class="form_group mr-9">
                                <label class="form_label">Комментар до замовлення</label>
                                <div class="textarea_container">
                                    <textarea v-model="commercialOfferData.comment" class="form_input form_textarea" maxlength="200" rows="5" placeholder="Коментар"></textarea>
                                    <span class="total_words">{{ commercialOfferData.comment ? commercialOfferData.comment.length : 0 }} / 200</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="commercial_offer_order" v-if="commercial_offer_sended">
                        <div class="block_row">
                            <p class="commercial_offer_order_title">Заявка №{{commercial_offer_id}} від</p>
                            <svg id="close_offer" @click="() => {commercial_offer_sended = false; is_disable_commercial_offer_btn = false}" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"></path>
                            </svg>
                        </div>
                        <p class="commercial_offer_order_title">{{commercial_offer_created_at}}</p>
                        <p class="commercial_offer_order_text">Ваша запит на Комерційну пропозицію  зареєстрований та прийнятий, найближчим часом наш менеджер з Вами зв’яжеться. </p>
                    </div>

                    <a href="javascript:void(0)" v-if="!commercial_offer_sended" :disabled="is_disable_commercial_offer_btn" class="commercial_offer_order_btn" @click="commercialOrder()">
                        <template v-if="is_disable_commercial_offer_btn">
                            Зачекайте... <ProgressSpinner strokeWidth="5" style="width: 30px; height: 30px; margin: 0; margin-left: 30px;" />
                        </template>
                        <template v-else>Замовити</template>
                    </a>
                    <a href="javascript:void(0)" v-else class="commercial_offer_order_btn disabled">
                        Замовити
                    </a>
                </div>
            </div>

        </div>

        <div class="modal product_media_modal" v-if="opensSliderModal">
            <div class="modal_container">
                <svg id="close_modal" v-on:click="() => {opensSliderModal = false; overlay = false;}" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                </svg>
                <div class="modal_content">
                    <div class="product_media_modal_main_img_container">
                        <template v-if="preItem.selectedProductMediaFiles.length && preItem.selectedProductMediaFiles[selectedMediaIndex].type === 'photo' && !preItem.no_bodie">
                            <img :src="preItem.selectedProductMediaFiles[selectedMediaIndex].url" class="product_media_modal_main_img"/>
                        </template>
                        <template v-else-if="preItem.selectedProductMediaFiles.length && preItem.selectedProductMediaFiles[selectedMediaIndex].type === 'video' && !preItem.no_bodie">
                            <iframe type="text/html"
                                class="product_media_modal_main_img"
                                :src="preItem.selectedProductMediaFiles[selectedMediaIndex].url"
                                frameborder="0"/>
                        </template>

                        <template v-else-if="preItem.no_bodie">
                            <img :src="defaultMedia[0].url" class="product_media_modal_main_img" alt="image">
                        </template>
                        <template v-else>
                            <img :src="defaultMedia[0].url" class="product_media_modal_main_img" alt="image">
                        </template>

                        <div class="group_btns" v-if="preItem.selectedProductMediaFiles.length && !preItem.no_bodie">
                            <a href="javascript:void(0)" @click="()=> {selectedMediaIndex > 0 ? selectedMediaIndex-- : selectedMediaIndex}">
                                <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7.91016 1.41L3.33016 6L7.91016 10.59L6.50016 12L0.500156 6L6.50016 0L7.91016 1.41Z" fill="#356EEF"/>
                                </svg>
                            </a>
                            <a href="javascript:void(0)" @click="modalNextMedia()">
                                <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.0898437 1.41L4.66984 6L0.0898437 10.59L1.49984 12L7.49984 6L1.49984 0L0.0898437 1.41Z" fill="#356EEF"/>
                                </svg>
                            </a>
                        </div>
                    </div>

                    <div class="product_media_modal_sub_images" v-if="preItem.selectedProductMediaFiles.length && !preItem.no_bodie">
                        <template v-for="(media, key) in preItem.selectedProductMediaFiles" :key="key">
                            <img v-if="media.type === 'photo'" :src="media.url" @click="selectedMediaIndex = key" class="product_media_modal_img" :class="{'active': selectedMediaIndex == key}"/>
                            <img v-else src="/img/video.png" @click="selectedMediaIndex = key" class="product_media_modal_img" :class="{'active': selectedMediaIndex == key}"/>
                        </template>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal warning_popup" v-if="warningPopup">
            <div class="modal_container">
                <svg id="close_modal" v-on:click="() => {warningPopup = false; overlay = false;}" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                </svg>
                <div class="modal_content">
                    <h3>Кількість модулів перевищує допустиме значення</h3>

                    <div class="confir_btn_group">
                        <a href="javascript:void(0)" class="edit_btn" @click="() => {warningPopup = false; overlay = false;}">Редагувати</a>
                        <a href="javascript:void(0)" class="confirm_btn" @click="addShield(true)">Прийняти</a>
                    </div>
                </div>
            </div>
        </div>

        <Transition>
        <div class="notification_bar" v-if="progressSaved">
            <span>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_4984_330032)">
                <path d="M13.7125 24.3004L7.4125 18.0004L5.3125 20.1004L13.7125 28.5004L31.7125 10.5004L29.6125 8.40039L13.7125 24.3004Z" fill="white"/>
                </g>
                <defs>
                <clipPath id="clip0_4984_330032">
                <rect width="36" height="36" fill="white"/>
                </clipPath>
                </defs>
                </svg>
                
                <b>Зміни збережені.</b> Дані та підбір автоматів та модульних контакторів: {{ progressSavedText }}
            </span>
        </div>
        </Transition>
        <Transition>
        <div class="notification_bar error" v-if="progressSavedError">
            <span>
                <svg fill="#000000" height="20" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
                    viewBox="0 0 460.775 460.775" xml:space="preserve">
                    <path d="M285.08,230.397L456.218,59.27c6.076-6.077,6.076-15.911,0-21.986L423.511,4.565c-2.913-2.911-6.866-4.55-10.992-4.55
                        c-4.127,0-8.08,1.639-10.993,4.55l-171.138,171.14L59.25,4.565c-2.913-2.911-6.866-4.55-10.993-4.55
                        c-4.126,0-8.08,1.639-10.992,4.55L4.558,37.284c-6.077,6.075-6.077,15.909,0,21.986l171.138,171.128L4.575,401.505
                        c-6.074,6.077-6.074,15.911,0,21.986l32.709,32.719c2.911,2.911,6.865,4.55,10.992,4.55c4.127,0,8.08-1.639,10.994-4.55
                        l171.117-171.12l171.118,171.12c2.913,2.911,6.866,4.55,10.993,4.55c4.128,0,8.081-1.639,10.992-4.55l32.709-32.719
                        c6.074-6.075,6.074-15.909,0-21.986L285.08,230.397z"/>
                </svg>
                
                <b>Помилка збереження!</b>
            </span>
        </div>
        </Transition>
    </section>
</template>

<script>
import PreloadForm from "@/Components/PreloadForm";
import Fieldset from 'primevue/fieldset';
import Dropdown from 'primevue/dropdown';
import RadioButton from 'primevue/radiobutton';
import InputNumber from 'primevue/inputnumber';
import Checkbox from 'primevue/checkbox';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import ColumnGroup from "primevue/columngroup";
import Button from "primevue/button";
import Dialog from "primevue/dialog";
import Row from "primevue/row";
import axios from "axios";
import CommonLayout from "@/Layouts/CommonLayout";
import Label from '../Jetstream/Label.vue';
import Input from '../Jetstream/Input.vue';
import CustomSelect from "../Components/CustomSelect2.vue";
import Tooltip from 'primevue/tooltip';
import ProgressSpinner from 'primevue/progressspinner';


export default {
    directives: {
        Tooltip,
    },
    props: {
        text: {
            type: String,
            required: false,
        }
    },

    components: {
        PreloadForm,
        Fieldset,
        Dropdown,
        RadioButton,
        InputNumber,
        Checkbox,
        TabView,
        TabPanel,
        DataTable,
        Column,
        Button,
        Dialog,
        ColumnGroup,
        Row,
        Input,
        Label,
        CustomSelect,
        ProgressSpinner
    },
    layout: CommonLayout,

    data() {
        return {
            modal_info: false,
            modal_docs: false,
            modal_total: false,
            summarize: false,

            add_item_modal: false,
            opensSliderModal: false,
            selectedMediaIndex: 0,

            defaultMedia: [],

            preItem: {
                title: null,
                count: 1,
                price: 0,
                summ: 0,
                accountings_type: 'Ні',
                accountings_product: null,
                equipments_products: [],
                shields_products: [],
                modules_count: null,
                protection: null,
                implementation: null,
                no_bodie: false,
                summModules1: 0,
                summModules2: 0,
                summModules3: 0,
                selectedProductMediaFiles: [],
            },

            items: [],

            totalSumm: 15000,

            payload: false,
            editMode: false,
            editKey: false,
            error: null,
            errors: [],
            hasFormError: false,
            accountings: [],
            products: [],
            line_products: [],
            equipments: [],
            modules_counts: [],
            protections: [],
            implementations: [],

            oldModules_counts: [],
            oldProtections: [],
            oldImplementations: [],

            specItems: [],
            summarizeResult: [],

            selectedProductMediaFiles: [],

            summModules1: 0,
            summModules2: 0,
            summModules2Old: 0,
            summModules3: 0,

            disabledShield: false,
            progressSaved: false,
            progressSavedError: false,
            progressSavedText: null,

            warningPopup: false,
            lineProductErrors: [],

            is_drop_commercial_offer: false,
            commercial_offer_sended: false,
            is_disable_commercial_offer_btn: false,
            commercial_offer_id: null,
            commercial_offer_created_at: null,
            commercialOfferData: {
                organization: null,
                name: null,
                phone: null,
                email: null,
                comment: null,
            },
            commercialOfferDataErrors: {
                phone: null,
                email: null,
            },
        }
    },

    watch: {
        'preItem.no_bodie': {
            handler: function(newVal, oldVal) {
                if (newVal) {
                    this.disabledShield = true
                    this.summModules2 = 0
                    this.preItem.modules_count = null
                    this.preItem.protection = null
                    this.preItem.implementation = null
                    this.preItem.selectedProductMediaFiles = []

                    this.modules_counts = this.oldModules_counts;
                    this.protections = this.oldProtections;
                    this.implementations = this.oldImplementations;
                } else {
                    this.summModules2 = this.summModules2Old
                    this.disabledShield = false
                }
            },
            deep: true
        },
        'line_products': {
            handler: function() {
                this.summModules3 = 0;
                this.lineProductErrors = [];
                this.line_products.forEach((value, index) => {
                    if (value.article && value.article.price_nds) {
                        this.summModules3 += parseInt(value.count) * parseFloat(value.article.dimensions)
                    }
                });
            },
            deep: true
        },
    },

    beforeMount () {
        window.addEventListener('keydown', this.handleKeydown, null);
    },
    mounted() {
        this.getData();
    },
    beforeDestroy () {
        window.removeEventListener('keydown', this.handleKeydown);
    },

    methods: {
        clearErrors() {
            this.errors = [];
            this.hasFormError = false;
        },

        acceptNumber() {
            var x = this.preItem.count.replace(/\D/g, '').match(/^[1-9][0-9]*$/);

            this.preItem.count = x;
        },
        
        clearBodies(type) {
            switch (type) {
                case 'modules_count':
                    this.preItem.modules_count = null
                    break;
                case 'protection': 
                    this.preItem.protection = null
                    break;
                case 'implementation': 
                    this.preItem.implementation = null
                    break;
            }

            this.getBodies()
        },

        handleKeydown (e) {
            if (this.opensSliderModal) {
                switch (e.keyCode) {
                    case 37:
                        this.selectedMediaIndex > 0 ? this.selectedMediaIndex-- : this.selectedMediaIndex
                        break;
                    case 39: 
                        this.modalNextMedia();
                        break;
                    case 27: 
                        this.opensSliderModal = false;
                        this.overlay = false;
                        break;
                }
            }
        },
        openAddModal() {
            this.selectedMediaIndex = 0;
            this.modules_counts = this.oldModules_counts;
            this.protections = this.oldProtections;
            this.implementations = this.oldImplementations
            this.editMode = false;
            this.line_products = [];
            this.preItem = {
                title: null,
                count: 1,
                price: 0,
                summ: 0,
                accountings_type: 'Ні',
                accountings_product: null,
                equipments_products: [],
                shields_products: [],
                modules_count: null,
                protection: null,
                implementation: null,
                no_bodie: false,
                summModules1: 0,
                summModules2: 0,
                summModules3: 0,
                selectedProductMediaFiles: [],
            };
            this.add_item_modal = true;
            this.summModules1 = 0;
            this.summModules2 = 0;
            this.summModules2Old = 0;
            this.summModules3 = 0;

            this.disabledShield = false;
        },
        editProduct(key) {
            this.selectedMediaIndex = 0;
            let oldItem = _.cloneDeep(this.items[key]);
            this.preItem = oldItem;
            this.summModules1 = oldItem.summModules1;
            this.summModules2 = oldItem.summModules2;
            this.summModules2Old = oldItem.summModules2Old;
            this.summModules3 = oldItem.summModules3;
            this.preItem.price = 0;
            this.preItem.summ = 0;
            this.line_products = this.preItem.equipments_products;
            this.preItem.equipments_products = [];

            this.add_item_modal = true;
            this.editMode = true;
            this.editKey = key

            this.$forceUpdate();
        },
        addShield(isConfirm = false) {
            this.errors = [];
            this.lineProductErrors = [];
            this.hasFormError = false;

            if (!this.preItem.title) {
                this.errors.title = true;
                this.hasFormError = true;
                this.scrollTop('addMoadal');
                return false
            }
            if (!this.preItem.count) {
                this.errors.count = true;
                this.hasFormError = true;
                this.scrollTop('addMoadal');
                return false
            }
            if (!this.preItem.accountings_type) {
                this.errors.accountings_type = true;
                this.hasFormError = true;
                this.scrollTop('addMoadal');
                return false
            }

            if (!this.preItem.no_bodie) {
                if (!this.preItem.modules_count) {
                    this.errors.modules_count = true;
                    this.hasFormError = true;
                    this.scrollTop('addMoadal');
                    return false
                }
                if (!this.preItem.protection) {
                    this.errors.protection = true;
                    this.hasFormError = true;
                    this.scrollTop('addMoadal');
                    return false
                }
                if (!this.preItem.implementation) {
                    this.errors.implementation = true;
                    this.hasFormError = true;
                    this.scrollTop('addMoadal');
                    return false
                }
            }

            if (!isConfirm && !this.preItem.no_bodie && ((this.summModules1 + this.summModules3) > this.summModules2)) {
                this.warningPopup = true
                return;
            } else {
                this.warningPopup = false;
                this.overlay = false;
            }

            this.line_products.forEach((value, index) => {
                if (value.equipment && value.pole_number && value.characteristic && value.power) {
                    if (value.article && value.article.price_nds) {
                        this.preItem.price += value.count * value.article.price_nds;
                        this.preItem.summ += value.count * value.article.price_nds;

                        this.preItem.equipments_products.push(value);
                    }
                } else {
                    this.lineProductErrors.push(index)
                }
            });

            if (this.lineProductErrors.length) {
                this.progressSavedError = true
                setTimeout(function () { this.progressSavedError = false }.bind(this), 1500)
                return;
            }

            if (this.preItem.accountings_product && this.preItem.accountings_product.price_nds) {
                this.preItem.price += this.preItem.accountings_product.count * this.preItem.accountings_product.price_nds;
                this.preItem.summ += this.preItem.accountings_product.count * this.preItem.accountings_product.price_nds;
            }

            if (!this.preItem.no_bodie) {
                this.preItem.shields_products.forEach((value, index) => {
                    if (value.article && value.price_nds) {
                        this.preItem.price += value.count * value.price_nds;
                        this.preItem.summ += value.count * value.price_nds;
                    }
                });
            }

            this.preItem.summModules1 =  this.summModules1;
            this.preItem.summModules2 =  this.summModules2;
            this.preItem.summModules2Old =  this.summModules2Old;
            this.preItem.summModules3 =  this.summModules3;

            if (!this.editMode) {
                this.items.push(this.preItem);
            } else {
                let preItem = _.cloneDeep( this.preItem );

                this.items[this.editKey] = preItem;

                this.progressSaved = true
                this.progressSavedText = preItem.title

                setTimeout(function () { this.progressSaved = false }.bind(this), 1500)
            }

            this.add_item_modal = false;

            this.line_products = [];
            this.preItem = {
                title: null,
                count: 1,
                price: 0,
                summ: 0,
                accountings_type: 'Ні',
                accountings_product: null,
                equipments_products: [],
                shields_products: [],
                modules_count: null,
                protection: null,
                implementation: null,
                no_bodie: false,
                summModules1: 0,
                summModules2: 0,
                summModules3: 0,
                selectedProductMediaFiles: [],
            };

            this.errors = [];
            this.hasFormError = false;
            this.editMode = false;
            this.editKey = null;

            this.$forceUpdate();
        },

        scrollTop(id) {
            const el = document.getElementById(id);

            if (el) {
                el.scrollTop = 0;
            }
        },

        addProduct() {
            this.clearErrors();

            this.line_products.push({
                equipment: null,
                pole_number: null,
                characteristic: null,
                power: null,
                count: 1,
                article: null,

                equipments: [],
                pole_numbers: [],
                characteristics: [],
                powers: [],
            });

            this.$forceUpdate();
        },

        plusProductCount(key) {
            this.clearErrors();
            this.line_products[key].count++;

            this.$forceUpdate();
        },

        minusProductCount(key) {
            this.clearErrors();
            if (this.line_products[key].count > 1) {
                this.line_products[key].count--
            }

            this.$forceUpdate();
        },

        deleteProduct(key) {
            this.clearErrors();
            this.line_products.splice(key, 1);

            this.$forceUpdate();
        },

        isMobile() {
            return window.innerWidth <= 1024;
        },
        numberWithSpaces(x) {
            x = parseFloat(x);
            x = x.toFixed(2);
            var parts = x.toString().split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            return parts.join(",");
        },

        summTotal() {
            let summ = 0;
            
            this.items.forEach((value, index) => {
                let itemSumm = value.count * value.price;
                summ += itemSumm;
                value.summ = itemSumm;
            });

            return this.numberWithSpaces(summ);
        },

        copyItem(index, item) {
            this.selectedMediaIndex = 0;
            this.editMode = true

            let items = _.cloneDeep( this.items );
            item.title = item.title.replace(' копія', '');
            item.title = item.title + ' копія';
            items.splice(index, 0, item);

            this.items = items;
        },

        deleteItem(key) {
            this.selectedMediaIndex = 0;
            this.items.splice(key, 1);
        },

        getData() {
            this.payload = true;
            this.error = false;
            axios.post(this.route('api.get_data'))
                .then((result) => {
                    this.equipments = result.data.equipments;
                    this.accountings = result.data.accountings;
                    this.modules_counts = result.data.modules_counts;
                    this.protections = result.data.protections;
                    this.implementations = result.data.implementations;
                    this.oldModules_counts = result.data.modules_counts;
                    this.oldProtections = result.data.protections;
                    this.oldImplementations = result.data.implementations;
                    this.defaultMedia = result.data.default_media;

                    this.payload = false;
                }).catch((error) => {
                    this.error = true;
                    window.scroll(0, 0);
                })
        },

        getAccountings() {
            this.clearErrors()
            if (this.preItem.accountings_type !== 'Ні') {
                this.payload = true;
                this.error = false;
                axios.post(this.route('api.get_accountings_data', {accountings_type: this.preItem.accountings_type}))
                    .then((result) => {
                        this.preItem.accountings_product = result.data.accounting;

                        this.summModules1 = parseInt(result.data.summModules);
                        this.payload = false;
                    }).catch((error) => {
                        this.error = true;
                        window.scroll(0, 0);
                    })
            } else {
                this.summModules1 = 0;
                this.preItem.accountings_product = null;
            }
        },
        getBodies() {
            this.selectedMediaIndex = 0;
            this.errors = [];
            this.hasFormError = false;
            this.preItem.no_bodie = false;

            if (!this.preItem.modules_count || !this.preItem.protection || !this.preItem.implementation) {
                this.preItem.selectedProductMediaFiles = []
            }
            
            // if (!this.preItem.modules_count) {
            //     this.errors.modules_count = true;
            //     this.hasFormError = true;
            //     this.scrollTop('addMoadal');
            //     return false
            // }
            // if (!this.preItem.protection) {
            //     this.errors.protection = true;
            //     this.hasFormError = true;
            //     this.scrollTop('addMoadal');
            //     return false
            // }
            // if (!this.preItem.implementation) {
            //     this.errors.implementation = true;
            //     this.hasFormError = true;
            //     this.scrollTop('addMoadal');
            //     return false
            // }

            this.payload = true;
            this.error = false;
            axios.post(this.route('api.get_bodies_data', {
                    modules_count: this.preItem.modules_count,
                    protection: this.preItem.protection,
                    implementation: this.preItem.implementation,
                }))
                .then((result) => {
                    this.modules_counts = result.data.modules_counts;
                    this.protections = result.data.protections;
                    this.implementations = result.data.implementations;
                    this.preItem.shields_products = result.data.products;
                    this.summModules2 = parseInt(result.data.summModules);
                    this.summModules2Old = parseInt(result.data.summModules);


                    if (result.data.media.length) {
                        this.preItem.selectedProductMediaFiles = result.data.media;
                    }
                    
                    this.payload = false;
                    this.$forceUpdate();
                }).catch((error) => {
                    this.error = true;
                    window.scroll(0, 0);
                })
        },

        getArticle(i, eq = false) {
            this.clearErrors();
            this.line_products[i].article = null;

            if (eq) {
                this.line_products[i].pole_number = null;
                this.line_products[i].characteristic = null;
                this.line_products[i].power = null;
            }

            this.payload = true;
            axios.post(this.route('api.sho_125'), {
                equipment: this.line_products[i].equipment,
                pole_number: this.line_products[i].pole_number,
                char: this.line_products[i].characteristic,
                power: this.line_products[i].power,
            })
            .then((result) => {
                this.line_products[i].pole_numbers = result.data.poluses;
                this.line_products[i].characteristics = result.data.chars;
                this.line_products[i].powers = result.data.powers;

                if (result.data.auto) {
                    this.line_products[i].pole_number = result.data.autoPolus;
                    this.line_products[i].characteristic = result.data.autoChar;
                    this.line_products[i].power = result.data.autoPower;
                }

                // if (result.data.poluses.length === 1 || !result.data.poluses.length) {
                //     // this.line_products[i].pole_numbers = null;

                //     this.line_products[i].pole_number = result.data.poluses[0] ? result.data.poluses[0] : null;
                // }
                // if (result.data.chars.length === 1 || !result.data.chars.length) {
                //     this.line_products[i].characteristic = result.data.chars[0] ? result.data.chars[0] : null;
                // }
                // if (result.data.powers.length === 1 || !result.data.powers.length) {
                //     this.line_products[i].power = result.data.powers[0] ? result.data.powers[0] : null;
                // }

                // if ( (this.line_products[i].pole_number ||  !this.line_products[i].pole_number) && this.line_products[i].characteristic && this.line_products[i].power) {
                //     this.getArticle(i);
                // }

                this.line_products[i].article = result.data.item;
                this.payload = false;
            }).catch((error) => {
                console.log(error);
                window.scroll(0, 0);
            })
        },

        getSpec() {
            if (!this.items.length) {
                return;
            }

            this.specItems = [];

            let items = _.cloneDeep(this.items)

            let products = [];

            items.forEach((value, index) => {
                if (!products[index]) {
                    products[index] = {
                        title: value.title,
                        products: [],
                    };
                }
                if (value.accountings_product) {
                    value.accountings_product.count = parseInt(value.count) * parseInt(value.accountings_product.count);
                    products[index].products.push(value.accountings_product);
                }
                if (value.equipments_products.length) {
                    value.equipments_products.forEach((item, key) => {
                        item.article.count = parseInt(value.count) * parseInt(item.count)
                        products[index].products.push(item.article);
                    });
                }
                if (value.shields_products.length && !value.no_bodie) {
                    value.shields_products.forEach((item, key) => {
                        item.count = parseInt(value.count) * parseInt(item.count)
                        products[index].products.push(item);
                    });
                }
            });

            this.specItems = products;

            this.modal_total = true;

            this.$forceUpdate();
        },
        
        summProducts(items) {
            let summ = 0;

            items.forEach((item, index) => {
                summ += item.count * (item.price_nds/1.2);
            });

            return this.numberWithSpaces(summ);
        },
        
        productsPdw(items) {
            let summ = 0;
            let summPdv = 0;

            items.forEach((item, index) => {
                summ += item.count * item.price_nds;
            });

            items.forEach((item, index) => {
                summPdv += item.count * (item.price_nds/1.2);
            });

            return this.numberWithSpaces(summ - summPdv);
        },
        
        summProductsPdw(items) {
            let summ = 0;

            items.forEach((item, index) => {
                summ += item.count * item.price_nds;
            });

            return this.numberWithSpaces(summ);
        },

        doSummarize() {
            this.summarize = !this.summarize;
            this.summarizeResult = [];
            let articles = [];

            let items = _.cloneDeep(this.specItems)

            let preSumm = [];

            items.forEach((item, index) => {
                item.products.forEach((product, key) => {
                    preSumm.push(product);
                });
            });

            preSumm.forEach((v, index) => {
                if (v.article) {

                    if (articles.includes(v.article)) {

                        let obj = preSumm.find((o, i) => {
                            if (o.article === v.article) {
                                preSumm[i].count = parseInt(v.count) + parseInt(o.count);
                                return true; // stop searching
                            }
                        });

                    } else {
                        articles.push(v.article);
                        this.summarizeResult.push(v);
                    }

                } else {
                    this.summarizeResult.push(v);
                }
            });

            this.$forceUpdate();
        },

        getExcel() {
            if (!this.items.length) {
                return;
            }

            this.getSpec()
            // this.modal_total = false;

            axios.post(this.route('api.sho125_get_excel'), {
                items: this.summarize ? this.summarizeResult : this.specItems,
                summarize: this.summarize,
            })
            .then((response) => {
                var fileURL = response.data.data;
                    var fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', response.data.name);
                document.body.appendChild(fileLink);
                fileLink.click();
            }).catch((error) => {
                console.log(error);
                window.scroll(0, 0);
            })
        },

        modalNextMedia() {
            if (this.selectedMediaIndex <= this.preItem.selectedProductMediaFiles.length - 2) {
                this.selectedMediaIndex++
            } else {
                this.selectedMediaIndex = 0
            }
            this.$forceUpdate();
        },
        opensSliderModalAction() {
            this.opensSliderModal = !this.opensSliderModal;
            this.overlay = true;
            this.$forceUpdate();
        },

        closeModals() {
            if (this.opensSliderModal) {
                this.opensSliderModal = false
            } else if (this.warningPopup) {
                this.warningPopup = false;
            } else {
                this.modal_info = false;
                this.add_item_modal = false;
                this.modal_total = false;
            }
        },

        dropCommercialOfferForm() {
            this.is_drop_commercial_offer = !this.is_drop_commercial_offer
        },
        acceptNumber() {
            var x = this.commercialOfferData.phone.replace(/\D/g, '').replace('380', '').replace('38', '').match(/(\d{0,2})(\d{0,3})(\d{0,4})/);

            this.commercialOfferData.phone = !x[2] && x[1] ? '+380' + x[1] : (x[1] ? '+38 (0' + x[1] + ') ' : '+380') + x[2] + (x[3] ? '-' + x[3] : '');
        },
        commercialOrder() {
            if (!this.commercialOfferData.phone) {
                this.commercialOfferDataErrors.phone = true;
                return false;
            } else {
                this.commercialOfferDataErrors.phone = false;
            }
            if (!this.commercialOfferData.email || !(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.commercialOfferData.email))) {
                this.commercialOfferDataErrors.email = true;
                return false;
            } else {
                this.commercialOfferDataErrors.email = false;
            }

            if (!this.is_disable_commercial_offer_btn) {
                this.is_disable_commercial_offer_btn = true;

                axios.post(this.route('make-offer'), {
                    type: 'Sho125Service',

                    items: this.summarize ? this.summarizeResult : this.specItems,
                    summarize: this.summarize,

                    organization: this.commercialOfferData.organization,
                    phone: this.commercialOfferData.phone,
                    name: this.commercialOfferData.name,
                    email: this.commercialOfferData.email,
                    comment: this.commercialOfferData.comment,
                    total_price: this.summProductsPdw(this.summarizeResult),
                })
                .then((response) => {
                    this.commercial_offer_id = response.data.id;
                    this.commercial_offer_created_at = response.data.created_at;

                    this.commercial_offer_sended = true;

                    this.commercialOfferData.organization = null
                    this.commercialOfferData.name = null
                    this.commercialOfferData.phone = null
                    this.commercialOfferData.email = null
                    this.commercialOfferData.comment = null
                }).catch((error) => {
                    this.is_disable_commercial_offer_btn = false;
                    console.log(error);
                    window.scroll(0, 0);
                })
            }
        }
    }
};
</script>

<style scoped>
a.disabled {
    cursor:not-allowed;
    filter: opacity(0.5);
}

#form_section {
    max-width: 1296px;
    margin: 0 auto;
}
.container {
    padding: 80px 25px 0 20px;
}
.service_header {
    display: flex;
    justify-content: space-between;
}
.service_title {
    font-style: normal;
    font-weight: 700;
    font-size: 36px;
    line-height: 43px;
    color: #212529;
}
.info_btn {
    width: 251px;
    height: 48px;
    padding: 12px 30px;
    border: 1px solid #356EEF;
    color: #356EEF;
    border-radius: 4px;
    display: flex;
    align-items: center;
    gap: 10px;
}

.overlay {
    z-index: 1;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    cursor: pointer;
    background: rgba(0, 0, 0, 0.45);
}

.modal {
    position: fixed;
    z-index: 101;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
    z-index: 2;
    width: 466px;
    height: auto;
    padding: 30px 30px 30px 30px;
    background: #FFFFFF;
    box-shadow: 0px 8px 36px rgba(0, 0, 0, 0.16);
    border-radius: 15px;
    z-index: 999;
}

.modal_header {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #CED4DA;
    width: 100%;
    padding-bottom: 10px;
    position: relative;
    align-items: center;
}

.modal_header_title {
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 27px;
    text-align: center;
    color: #000000;
    padding: 0;
    margin: 0;
}

#close_modal {
    cursor: pointer;
}

.modal_content {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #151920;
    margin-top: 14px;
}

.add_item_modal {
    width: 92%;
}

.add_item_modal .modal_header {
    border-bottom: none;
}

.add_item_modal .modal_header_title {
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 36px;
    color: #000000;
}

@media (max-width: 780px) {
    .container {
        padding: 50px 0 0 0;
    }
    .service_header {
        flex-direction: column;
    }
}

@media (max-width: 420px) {
    .modal {
        width: 385px;
    }
    .service_title {
        font-size: 27px;
        line-height: 36px;
    }
}

.top_bar {
    margin-top: 80px;
    margin-bottom: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.top_bar .top_bar_title {
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 36px;
    color: #000000;
}

.top_bar .add_btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 202px;
    height: 48px;
    background: #356EEF;
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #FFFFFF;
    padding-left: 30px;
    padding-right: 30px;
}

.main_table {
    width:100%;
    border-radius: 4px 4px 0px 0px;
}

.main_table, th, td {
  border: 1px solid #DEE2E6;
  border-collapse: collapse;
}

.main_table_title {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #212529;
    height: 54px;
}

.main_table_row {
    height: 53px;
}

.main_table_count_input {
    width: 60px;
    height: 36px;
    background: #FFFFFF;
    border: 1px solid #DEE2E6;
    border-radius: 6px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    text-align: center;
    color: #000000;
}

.edit_row {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 15px;
}

.total_btns {
    display: flex;
    gap: 26px;
}

.view_spec_btn {
    width: 264px;
    height: 48px;
    background: #356EEF;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #FFFFFF;
    cursor: pointer;
}

.view_spec_btn.disabled {
    background: #DEE2E6;
    color: #6C757D;
}

.download_spec {
    width: 323px;
    height: 48px;
    background: #FFFFFF;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #000000;
    cursor: pointer;
}

.download_spec.disabled {
    color: #6C757D;
}

.total_summ {
    display: flex;
    align-items: center;
    justify-content: center;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
    gap: 38px;
}

.subtitle {
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 27px;
    color: #000000;
}

.form_row {
    display: flex;
    gap: 100px;
}

.input_group {
    display: flex;
    gap: 24px;
}

.form_input_item {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.form_input_title {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
}

.form_input {
    width: 306px;
    height: 48px;
    background: #FFFFFF;
    border: 1px solid #CED4DA;
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
    padding: 10px 16px;
}
.form_select {
    padding: 10px 16px;
    width: 306px;
    height: 48px;
    border: 1px solid #CED4DA;
    border-radius: 4px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10.59 0.0898438L6 4.66984L1.41 0.0898438L0 1.49984L6 7.49984L12 1.49984L10.59 0.0898438Z' fill='%23356EEF'/%3E%3C/svg%3E%0A");
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    background-size: 12px 7px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
}

.form_border {
    border: 1px solid rgba(206, 212, 218, 0.4);
    border-radius: 4px;
    padding: 12px;
    margin-top: 20px;
}

.checkbox_input {
    padding: 0;
    margin: 0;
    margin-right: 9px;
}

.form_border .input_group {
    margin-top: 24px;
}

.line_table {
    margin-top: 30px;
}

.line_table select {
    padding-right: 40px;
}

.line_table thead th {
    height: 72px!important;
}

.line_table tbody tr {
    height: 55px!important;
}

.line_table table {
    table-layout:fixed;
}


table {
  margin: 0 auto;
}

/* Default Table Style */
table {
  color: #333;
  background: white;
  border: 1px solid grey;
  font-size: 12pt;
  border-collapse: collapse;
}
table thead th,
table tfoot th {
  text-align: start;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #212529;
}
table caption {
  padding:.5em;
}
table th,
table td {
    border: 1px solid #DEE2E6;
}

.delete_td {
    padding: 22px 10px 24px 20px;
}

.add_btn {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
    display: flex;
    align-items: center;
    gap: 16px;
}

.option_select {
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    text-indent: 1px;
    text-overflow: '';
    user-select: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    -webkit-tap-highlight-color: rgba(0,0,0,0);

    background-image: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10.59 0.0898438L6 4.66984L1.41 0.0898438L0 1.49984L6 7.49984L12 1.49984L10.59 0.0898438Z' fill='%23356EEF'/%3E%3C/svg%3E%0A");
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    background-size: 12px 7px;
    background-color: #FFFFFF;

    border: none;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
    width: 100%;
}

.count_td {
    padding: 10px 22px 10px 0px;
}

.count_td .count span {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
}

.count_td .count a {
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 25px;
}

.count {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 25px;
    color: #000000;
}

.count a {
    color: #000000;
}

.ol_num {
    width: 50px;
    text-align: center;
}

.ol_eq {
    width: 288px;
    max-width: 288px;
    padding-left: 22px;
    padding-right: 12px;
}

.ol_eq__select {
    width: 240px;
    max-width: 240px;
}

.ol_p_ctn {
    width: 217px;
    max-width: 217px;
    padding-left: 22px;
    padding-right: 12px;
}

.ol_p_ctn__select {
    width: 174px;
    max-width: 174px;
}

.ol_char {
    width: 205px;
    max-width: 205px;
    padding-left: 22px;
    padding-right: 12px;
}

.ol_char__select {
    width: 166px;
    max-width: 166px;
}

.ol_curr {
    width: 189px;
    max-width: 189px;
    padding-left: 22px;
    padding-right: 12px;
}

.ol_curr__select {
    width: 148px;
    max-width: 148px;
}

.ol_cnt {
    width: 128px;
    padding-left: 22px;
}

.ol_article {
    width: 172px;
    max-width: 172px;
    padding-left: 22px;
}

.ol_close {
    width: 46px;
    padding-left: 16px;
}

.summ_point {
    text-align: flex-end;
    padding-right: 22px;
}

.summ_value {
    text-align: center;
    padding-right: 22px;
}

.variation_table {
    padding-top: 70px;
}

.variation_table_footer {
    padding-left: 42px;
    padding-right: 42px;
    display: flex;
    justify-content: space-between;
}
.module_ctn_container {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
}
.module_ctn {
    display: flex;
    align-items: center;
    gap: 10px;
}
.module_ctn_title {
    margin: 0px;
    padding: 0px;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
}
.module_ctn_input {
    width: 86px;
    height: 36px;
    background: #FFFFFF;
    border: 1px solid #CED4DA;
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    text-align: center;
    color: #000000;
}
.btn_container {
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
}
.border-danger {
    border: 1px solid red;
    color: red;
}
.error_text {
    color: red;
}
.modal_total {
    width: 90%;
    top: 435px;
    max-width: 1296px;
    height: 80vh;
    overflow: auto;
}

.modal_total .modal_content{
    overflow: auto;
    height: 470px;
    font-size: 14px;
    line-height: 21px;
    margin: 0px;
}
.modal_total .title{
    margin: 0px;
    padding: 0px;
    margin-bottom: 10px;
}

.modal_total table {
    table-layout: fixed;
    font-size: 14px;
    line-height: 21px;
}

.title {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #212529;
}

.total_key {
    width: 22px;
    padding: 0;
    height: 38px;
    padding-right: 22px;
    text-align: center;
}
.total_title {
    width: 140px;
    padding: 0;
    padding-right: 22px;
    height: 38px;
}
.total_maker {
    width: 62px;
    padding: 0;
    padding-right: 22px;
    height: 38px;
}
.total_count {
    width: 30px;
    text-align: center;
    padding-right: 22px;
    height: 38px;
}
.total_od {
    width: 30px;
    text-align: center;
    padding-right: 22px;
    height: 38px;
}
.total_price {
    width: 30px;
    text-align: center;
    padding-right: 22px;
    height: 38px;
}
.total_summ2 {
    width: 30px;
    text-align: center;
    padding-right: 22px;
    height: 38px;
}
.total_tech {
    width: 30px;
    text-align: center;
    height: 38px;
}
.center {
    text-align: center;
    height: 38px;
}
.totat_tr {
    height: 38px;
}

.summ_text {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
}

.modal_bottom {
    display: flex;
    justify-content: space-between;
    padding-top: 20px;
    width: 100%;
}

.modal_bottom_link {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-decoration-line: underline;
    color: #356EEF;
    cursor: pointer;
}

.modal_bottom__btns {
    display: flex;
    align-items: center;
    gap: 30px;
}

.avr_summ_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 154px;
    height: 48px;
    background: #356EEF;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #FFFFFF;
    cursor: pointer;
}

.avr_excel_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 203px;
    height: 48px;
    background: #FFFFFF;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #000000;
    cursor: pointer;
}

.modal_total table th, .modal_total table td, .modal_total table {
    border: none;
}
.modal_total thead {
    border-bottom: 1.5px solid #356EEF;
}
.modal_total tr {
    border-bottom: 1px solid #C8E4FF;
}
.modal_total tr:hover {
    background-color: #F0F8FF;
}
.modal_total .modal_header {
    border-bottom: none;
}

.product_media_modal .modal_content {
    max-height: 70vh;
    margin-top: 0px;
}
.product_media_modal {
    padding: 0px;
    border-radius: 0px;
    z-index: 10000!important;
}
.product_media_modal #close_modal{
    position: absolute;
    right: 20px;
    top: 10px;
    z-index: 1;
}
.warning_popup #close_modal{
    position: absolute;
    right: 20px;
    top: 20px;
    z-index: 1;
}

.warning_popup {
    z-index: 100000;
}

.warning_popup h3 {
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 36px;
    color: #000000;
}

.warning_popup .confir_btn_group {
    display: flex;
    justify-content: left;
    gap: 15px;
    padding: 10px 0px;
}

.warning_popup .edit_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 48px;
    background: #356EEF;
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #FFFFFF;
    padding-left: 30px;
    padding-right: 30px;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
}

.warning_popup .confirm_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 48px;
    background: #FFFFFF;
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #6C757D;
    padding-left: 30px;
    padding-right: 30px;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
}

.block_images {
    display: flex;
    gap: 20px;
}

.sub_images {
    display: flex;
    flex-direction: column;
    gap: 2px;
    max-height: 200px;
    overflow: auto;
}

.product_media_modal_sub_images {
    width: 100%;
    display: flex;
    gap: 17px;
    overflow: auto;
    padding: 5px 10px 0px 10px;
    margin-bottom: 10px;
}

.product_img {
    width: 55px;
    height: auto;
    cursor: pointer;
}

.product_media_modal_img {
    width: 48px;
    height: 48px;
    cursor: pointer;
}

.main_img_container {
    position: relative;
    cursor: pointer;
    display: flex;
    justify-content: center;
    width: 180px;
}
.main_img_container svg {
    position: absolute;
    bottom: 8px;
    right: 8px;
    cursor: pointer;
}

.product_info_text {
    margin: 0;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #212529;
    margin-top: 10px;
}

.product-item.active {
    background-color: #C8E4FF;
}
.product_img.active {
    border: 1px solid #C8E4FF;
}
.product_media_modal_img.active {
    border: 1px solid #C8E4FF;
}
.product_video_iframe {
    pointer-events: none;
}

.product_media_modal_main_img {
    width: 100%;
    height: auto;
    max-height: 465px;
}
.product_media_modal_main_img_container {
    position: relative;
    min-height: 58vh;
    display: flex;
    align-items: center;
}
.product_media_modal_main_img_container .group_btns {
    display: flex;
    gap: 30px;
    position: absolute;
    bottom: 20px;
    right: 20px;
}

.zindexed {
    z-index: 9999!important;
}

#addMoadal {
    max-height: 70vh;
}

.input-disabled {
    color: #6C757D!important;
}

.form_input_item_checkbox {
    display: flex;
}

.select_container {
    position: relative;
}

.select_container .clear_icon {
    position: absolute;
    top: 17px;
    right: 35px;
    cursor: pointer;
}

.form_input_title_row {
    display: flex;
    justify-content: space-between;
}

.accountings_type_file_link {
    font-size: 12px;
    color: #356EEF;
    text-decoration: underline;
}

.non_selected {
    color: #6C757D!important;
}

@media (max-width: 960px) {
    .total_key {
        width: 30px;
    }
    .total_title {
        padding-top: 15px;
        padding-bottom: 15px;
        width: 280px;
    }
    .total_maker {
        width: 125px;
    }
    .total_count {
        width: 90px;
    }
    .total_od {
        width: 90px;
    }
    .total_price {
        width: 90px;
    }
    .total_tech {
        width: 90px;
    }
    .add_item_modal .btn_container {
        justify-content: start;
    }
}

@media (max-width: 920px) {
    .main_table_container {
        width: 100%;
        overflow: auto;
    }
    .service_header {
        flex-direction: column;
    }
    .top_bar {
        flex-direction: column;
        justify-content: start;
        align-items: baseline;
    }
    .main_table_title {
        min-width: 120px;
    }

    .add_item_modal .input_group {
        flex-direction: column;
    }

    .add_item_modal .form_row {
        flex-direction: column;
        align-items: center;
    }

    .add_item_modal .info_form {
        width: 100%;
    }

    .add_item_modal .form_input {
        width: 100%;
    }

    .add_item_modal .form_select {
        width: 100%;
    }

    .add_item_modal .line_table {
        overflow: auto;
    }

    .add_item_modal .line_table thead th {
        min-width: 120px;
    }
    .modal_total .modal_bottom {
        flex-direction: column;
        gap: 20px;
    }

    .notification_bar {
        right: 10px!important;
        padding: 20px 20px!important;
        font-size: 12px!important;
    }
}

@media (max-width: 680px) {
    .notification_bar {
        right: 5px!important;
        padding: 12px 20px!important;
        font-size: 12px!important;
        line-height: 84%!important;
        height: auto!important;
    }
    .notification_bar span {
        gap: 9px;
        flex-direction: column;
        text-align: center;
    }
}

@media (max-width: 450px) {
    .modal_total {
        height: 655px;
        top: 350px;
    }
    .modal_total .modal_content {
        height: 355px;
    }
    .modal_total .modal_bottom__btns {
        flex-direction: column;
    }
    .modal_total .avr_summ_btn {
        width: 100%;
    }
    .modal_total .avr_excel_btn {
        width: 100%;
    }
}

@media (max-width: 400px) {
    .modal_total {
        height: 666px;
    }
}

@media (max-width: 390px) {
    .modal, .description_modal, .docs_modal, .modal_total {
        width: 330px;
    }
}

@media only screen and (max-height: 740px) and (min-width: 1200px) {
    .modal_total {
        top: 360px;
    }
    .modal_total .modal_content {
        height: 370px;
    }
}

@media screen and (min-width: 1900px){
    .add_item_modal {
        width: auto;
    }
}

.notification_bar {
    width: auto;
    padding: 20px 25px;
    height: 84px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 63px;
    right: 125px;
    border-radius: 4px;
    background: #6C99FF;
    box-shadow: -2px 4px 16px 0px rgba(0, 0, 0, 0.15);
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    line-height: 150%;
    z-index: 999;
}

.notification_bar.error {
    background: #ff5757;
}

.notification_bar.error svg path {
    fill: #FFFFFF;
}

.notification_bar span {
    display: flex;
    align-items: center;
    gap: 10px;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

tr.errors {
    border: 2px solid red;
}

.commercial_offer_header {
    border-radius: 4px;
    background: rgba(200, 228, 255, 0.45);
    padding: 24px 16px;
    display: flex;
    justify-content: space-between;
    margin-top: 24px;
    cursor: pointer;
}
.commercial_offer_header_title {
    color: #1C1C1C;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 21px;
}
.commercial_offer_drop_row {
    rotate: 180deg;
}
.commercial_offer_body {
    padding: 0px 16px 24px 16px;
    background: rgba(200, 228, 255, 0.45);
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
}
.flex-row, .flex-group {
    display: flex;
    flex-direction: row;
    gap: 24px;
}
.customer_info .form_input {
    max-width: 100%;
}
.flex_form {
    width: 100%;
}
.form_grid {
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
}
.form_group {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
}
.form_label {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
    display: flex;
    align-items: center;
}
.form_input {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    padding: 10px 16px;
    background: #FFFFFF;
    border: 1px solid #CED4DA;
    border-radius: 4px;
    max-width: 200px;
    height: 100%;
}
.error_text {
    color: red;
}
.form_textarea {
    max-width: 100%;
    height: auto;
}
.textarea_container {
    position: relative;
}
.total_words {
    position: absolute;
    right: 5px;
    bottom: 5px;
    color: rgb(95,99,104);
    font-size: 14px;
}
.commercial_offer_body .form_textarea {
    resize: none;
    width: 100%;
}
.commercial_offer_order_btn {
    border-radius: 4px;
    background: #356EEF;
    width: 282px;
    height: 48px;
    padding: 8px 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    margin-top: 24px;
}
.commercial_offer_order_btn.disabled {
    background: #CED4DA;
}
.block_row {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
#close_offer {
    cursor: pointer;
}
.commercial_offer_order_title {
    color: #212529;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 27px;
    margin: 0px;
}
.commercial_offer_order {
    margin-top: 24px;
    border-radius: 4px;
    border-left: 4px solid #356EEF;
    background: #FFF;
    padding: 16px;
}
.commercial_offer_order_text {
    margin-top: 12px;
}
@media (max-width: 1200px) {
    .customer_info {
        flex-direction: column;
    }
    .form_input {
        width: 100%!important;
    }
}
@media (max-width: 600px) {
    .flex-row {
        flex-direction: column!important;;
    }
    .commercial_offer_order_btn {
        width: 100%;
    }
}
@media (min-width: 1600px) {
    .modal_total {
        top: 40%;
        height: auto;
    }
}
</style>
